import React from 'react';
import { FormattedMessage } from 'react-intl';

export default (viewVerificationDetails) => ({
  pending_verification: {
    icon: 'processing-orange',
    header: (<FormattedMessage id="hosting.verification_status_data.pending_verification_header" defaultMessage="Pending verification" />),
    body: (<FormattedMessage id="hosting.verification_status_data.pending_verification_body" defaultMessage="Your account is being verified. You'll be notified if you need to provide any additional information." />),
    buttonText: (<FormattedMessage id="hosting.verification_status_data.pending_verification_button_text" defaultMessage="View Details" />),
    onClickAction: viewVerificationDetails
  },
  account_verified: {
    icon: 'check-mark-green',
    header: (<FormattedMessage id="hosting.verification_status_data.account_verified_header" defaultMessage="Account verified" />),
    body: (<FormattedMessage id="hosting.verification_status_data.account_verified_body" defaultMessage="Your account is ready to accept payouts." />),
    buttonText: (<FormattedMessage id="hosting.verification_status_data.account_verified_button_text" defaultMessage="View Details" />),
    onClickAction: viewVerificationDetails
  },
  more_information_needed: {
    icon: 'warning-orange',
    header: (<FormattedMessage id="hosting.verification_status_data.more_information_needed_header" defaultMessage="More information required" />),
    body: (<FormattedMessage id="hosting.verification_status_data.more_information_needed_body" defaultMessage="There was a problem verifying your account. Please enter the required information to activate payouts." />),
    buttonText: (<FormattedMessage id="hosting.verification_status_data.more_information_needed_button_text" defaultMessage="Verify Account" />),
    onClickAction: () => { location.href = '/account/verify'; },
    alertState: true
  },
  payouts_disabled: {
    icon: 'warning-orange',
    header: (<FormattedMessage id="hosting.verification_status_data.payouts_disabled_header" defaultMessage="Payouts disabled" />),
    body: (<FormattedMessage id="hosting.verification_status_data.payouts_disabled_body" defaultMessage="There is a problem with your account. Please contact Peerspace support." />),
    alertState: true
  }
});
